import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPcrIdSelector } from '../../home/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IAttachment, IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../user/selectors'
import { FillablePDFsConstants } from '../store/fillablePDFs.constants'
import { IFillablePDFsState } from '../store/fillablePDFs.types'
import { getFillablePDFsSelector } from '../selectors'
import { setFillablePDFsList } from '../store/fillablePDFs.actions'

export function* deleteFillablePDF() {
  const fillablePDFsState: IFillablePDFsState = yield select(getFillablePDFsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const { __deleteFillablePDFId } = fillablePDFsState

  if (!pcrID || !__deleteFillablePDFId) {
    return
  }

  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const newFillablePDFsList = pcrDoc.pdfAttachments?.filter((pdf: IAttachment) => pdf.id !== __deleteFillablePDFId)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      pdfAttachments: newFillablePDFsList,
    }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setFillablePDFsList(newFillablePDFsList))
  } catch (e) {
    yield put(throwPcrException(`deleteFillablePDF() error: ${e}`))
  }
}

export function* deleteFillablePDFSaga() {
  yield takeLatest([FillablePDFsConstants.DELETE_FILLABLE_PDF], performWithMutexHOG, deleteFillablePDF)
}
